<!--
vData:传入数据
cd(type,eData,iscb): 事件回调
type:message/invite/details/collect/live ==> 消息/邀请/详情/收藏/直播
eData:{}返回的数据
iscb:是否触发回调 默认是true
-->
<template>
  <div class="v-live-card box-shadow">
    <div class="v-live-group">
      <img v-lazy="$funcs.compressImage(vData.liveImgUrl, 380, 200)" alt="" class="v-live-group-bg lazy-img-fadein" />
      <div class="v-live-content v--video-img" @click="cb('live', vData)">
        <div class="v-live-header flex">
          <div class="v-live-header-left flex-start">
            <div class="img-box">
              <img :src="$funcs.compressImage(vData.anchorImgUrl, 28, 28) || defImage('head')" alt="" />
            </div>
            <div>
              <p v-if="vData.liveState != 1">{{ vData.liveWatchCount }} {{ $t('lives.looker') }}</p>
              <p v-else>{{ vData.liveWatchCount }} {{ $t('lives.looker') }}</p>
              <p>
                <span v-if="vData.anchorPost" class="v-live-user-num">{{ vData.anchorPost }}</span>
                <span class="v-live-user-name">{{ vData.anchorName }}</span>
              </p>
            </div>
          </div>
          <div class="v-live-header-rigth">
            <div class="zhibo-pointer">
              <span class="iconfont iconzhibo"></span>
              <span class="v-live-status">{{ $t('lives.status[' + vData.liveState + ']') }}</span>
            </div>
          </div>
        </div>
        <div class="v-live-body">
          <span class="icon-video"></span>
        </div>
        <div class="v-live-footer">
          <span class="time">{{ $t('live.startTime') }}: {{vData.liveStartDate | formatDate('all')}}</span>
        </div>
      </div>
    </div>
    <div class="v-exhibitor-group">
      <div class="v-exhibitor-header flex">
        <!-- 点赞 -->
        <!-- <div @click="cb('like', vData)" class="pointer" v-if="vData.liveState != 1"> -->
        <div v-if="vData.liveState != 1">
          <span class="iconfont iconact_dianzan_full"></span>
          <span>{{ vData.liveLikeCount }}</span>
          <span>{{ $t('like') }}</span>
        </div>
        <!-- 想看 -->
        <div @click="cb('miss', vData)" class="pointer relative" v-if="vData.liveState == 1">
          <span :class="['iconfont iconxiangkan iconmisslook pointer iconmiss_bg2',isT?'animation1':'']"></span>
          <span :class="['iconfont iconxiangkan iconmisslook pointer iconmiss_bg3',isT?'animation1':'']"></span>
          <span :class="['iconfont iconxiangkan iconmisslook pointer iconmiss_bg4',isT?'animation1':'']"></span>
          <span class="iconfont iconxiangkan iconmisslook pointer iconmiss_bg1"></span>
          <span>{{ vData.liveWantCount }}</span>
          <span>{{ $t('lives.miss') }}</span>
        </div>
        <div v-if="vData.liveParty == 2 && vData.liveSponsorId != (this.info.exhibitorEmployee?this.info.exhibitorEmployee.exhibitorId:null)" class="v-exhibitor-info theme-color pointer" @click="cb('details', vData)">
          {{ $t('exhibitorInfo') }}
        </div>
      </div>
      <div class="v-exhibitor-body">
        <v-swiper :option="option">
          <div slot="swiper-slide" slot-scope="slotProps" class="img-box" :style="{ width: option.imgW, height: option.imgH }">
            <img class="pointer lazy-img-fadein" @click="cb('exhibitsDetails', slotProps.slideData)" v-lazy="slotProps.slideData.icon" />
          </div>
        </v-swiper>
        <p class="ellipsis-4 v-live-desc ellipsis-2">{{ vData.liveName }}</p>
        <span class="v-commpay-name ellipsis">{{ vData.liveSponsorName }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import vSwiper from '@/components/vSwiper'
import { mapGetters } from 'vuex'
export default {
  props: {
    vData: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    return {
      index: 1,
      eN: 4, //临时变量
      option: {
        imgW: '110px',
        imgH: '72px',
        list: this.vData.productList ? this.vData.productList : []
      },
      isT:false
    }
  },
  components: {
    vSwiper
  },
  created() {},
  methods: {
    cb(type, eData, iscb = true) {
      if(eData.wantLive==0&&type=="miss"){//开启想看动画
        this.isT=true;
      }
      if (!iscb) return ''
      this.$emit('callback', { type: type, data: eData })
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'subjectType', 'info']),
    exibitsLength() {
      var num = 0
      num = this.eN / 3
      return Math.ceil(num)
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-live-card{
    width:100%;
    box-sizing: border-box;
    background: $color-white;
    transition: all .3s
    &:hover {
      box-shadow 0px 2px 5px 0px $box-shadow2
      box-shadow 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2
    }
}
.v-live-group:hover .icon-video{
    opacity 1
}
.icon-video {
  opacity 0
  transition opacity .3s
}
.v-live-group{
    width:100%;
    height: 200px;
    overflow: hidden;
    position: relative;
    cursor:pointer;
}
.v-live-group-bg{
    width:100%;
    height: 100%;
    object-fit cover;
}
.v-live-card .v-live-content{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    box-sizing :border-box;
    padding:12px;
    font-size:12px;
    color: $color-white;
    text-align:left;
    // text-shadow:0px 2px 4px $color-black;
    // background:linear-gradient(180deg,$color-white 0%,$color-black-45 100%);
    // background:$color-black-45;
}
.v-live-header-left .img-box{
    width:30px;
    height:30px;
    border-radius:50%;
    border:1px solid $color-blue-49;
    margin-right:9px;
}
.v-live-header-left .v-live-user-num{
    margin-right: 8px;
}
.v-live-footer{
    position :absolute;
    bottom :12px;
}
.v-exhibitor-group{
  padding:12px;
}
.v-exhibitor-group .v-exhibitor-header{
  font-size:12px;
  color:$color-black-65;
  margin-bottom:12px;
  line-height: 20px;
  height: 20px;
  .iconfont{
    margin: 0;
    margin-right: 9px;
  }
}
.v-exhibitor-group .v-exhibitor-header .iconact_dianzan_full{
  color:$color-red-fc;
  font-size:12px;
  // padding-right:8px;
}
.v-exhibitor-group .v-exhibitor-info{
  font-size:14px;
}
.v-exhibitor-body{
  text-align:left;
}
.v-exhibitor-body .img-box{
  width:110px;
  height :72px;
}
.v-exhibitor-body p{
  font-size:16px;
  color:$color-black-85 ;
  margin:12px 0 12px;
  line-height 1.6

}
.v-exhibitor-body .v-commpay-name{
  display: block;
  color:$color-black-65;
  font-size:14px;
}
.v-live-desc{
  height: 50px;
}
.iconmisslook{
  display:inline-block;
  width:16px;
  height:16px;
  line-height:16px;
  border-radius: 50%;
  font-size:12px;
  text-align:center;
  color:$color-white;
}
.iconmiss_bg1{
  background: $color-blue-49;
  position:relative;
  z-index:2;
}
.iconmiss_bg2{
  background:$color-blue-49;
  width:20px;
  height:20px;
  line-height:20px;
  position:absolute;
  top:0;
  left:10px;
  z-index:-1;
  transition:all 2s ease;
  font-size:12px!important;
}
.iconmiss_bg3{
  background:$color-red-ed;
  width:20px;
  height:20px;
  line-height:20px;
  position:absolute;
  top:0;
  left:10px;
  z-index:-1;
  transition:all 2s ease .5s;
  font-size:12px!important;
}
.iconmiss_bg4{
  background:$color-red-fc;
  width:20px;
  height:20px;
  line-height:20px;
  position:absolute;
  top:5px;
  left:10px;
  z-index:-1;
  transition:all 2s ease 0.8s;
  font-size:12px!important;
}
.animation1{
  z-index:1;
  transform:translate(18px,-60px) scale(2) translate(-10px,-80px);
  opacity:0;
}
.relative{
  position:relative
}
img.pointer {
  object-fit: contain
  background-color: $color-black-10
}
</style>
